import styled from "@emotion/styled";

const FooterInfo = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    gap: 5px;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    gap: 20px;
  }
`;

export default FooterInfo;
